<template>
  <footer>
    <!-- Footer Start-->
    <div class="footer-area fix">
      <div class="container">
        <div class="row d-flex justify-content-between">
          <div class="col-lg-5 col-md-5 col-xs-12">
            <div class="single-footer-caption">
              <div class="single-footer-caption">
                <!-- logo -->
                <!-- <div class="footer-logo">
                                    <a href="index.html"><img src="assets/img/logo.svg" alt=""></a>
                                </div> -->
                <div class="footer-tittle">
                  <div class="footer-pera">
                    <h4>CÔNG TY ĐẤU GIÁ HỢP DANH SỐ 5 - QUỐC GIA</h4>
                    <!-- <h5 class="mt-10" style="margin-bottom: 0px; color: white;"><strong>Công ty Đấu giá Hợp danh Số 5 - Quốc Gia</strong></h5> -->
                    <p style="margin-bottom: 0px;">
                      Giấy phép đăng ký hoạt động số: 45/TP-DKHD do Sở Tư pháp thành phố Hà Nội cấp ngày 21/02/2019
                    </p>
                    <p style="margin-bottom: 0px;">Số điện thoại: (+84) 24 37622619</p>
                    <p style="margin-bottom: 0px;">Email: daugiatructuyen.nalaf@gmail.com</p>
                    <p style="margin-bottom: 0px;">
                      Địa chỉ: Số 193 Hoàng Văn Thái, phường Khương Trung, quận Thanh Xuân, thành phố Hà Nội, Việt Nam
                    </p>
                  </div>
                </div>
                <!-- social -->
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-4 col-xs-12">
            <div class="footer__link">
              <h4 style="margin-bottom: 10px;">Chính sách</h4>
              <a href="/files/chinh_sach_hop_tac.pdf" target="_bank">Chính sách hợp tác</a>
              <a href="/files/quy_che_hoat_dong.pdf" target="_bank">Quy chế hoạt động website</a>
              <!-- <a href="/files/quy_trinh_khieu_nai.pdf" target="_bank">Quá trình giải quyết khiếu nại</a> -->
              <a href="/files/chinh_sach_bao_ve.pdf" target="_bank">Chính sách bảo vệ thông tin người dùng</a>
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-xs-12">
            <div class="instagram-gellay">
              <a href="http://online.gov.vn/Home/WebDetails/67358" target="_blank"
                ><img class="image-cert" src="@/assets/images/bocongthuong.png" style="width: 100%;"
              /></a>
              <!-- <h4>Album ảnh</h4>
                            <ul class="insta-feed">
                                <li><a href="#"><img src="" alt=""></a></li>
                            </ul> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="background-color: #e0e0e0 !important;text-align: center;font-size: 15px;">
      <p style="padding: 5px;margin-bottom: 0px;font-weight: 600;">
        Quyết định số 112/QĐ-STP của Sở Tư Pháp thành phố Hà Nội phê duyệt tổ chức đấu giá tài sản đủ điều kiện thực
        hiện hình thức đấu giá trực tuyến ngày 12/05/2020
      </p>
    </div>
    <!-- Footer End-->
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {};
  },
  methods: {}
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/Footer.vue